export default __webpack_public_path__ + "maps-examples-tracking-mode-thumbnail-960-5241a05789a287e367837d81ec1009fe.webp";